import React from 'react'
import {useField} from "formik";
import styles from './Number.module.scss';
import { useTranslation } from "react-i18next";
import {HelpText} from "../HelpText/HelpText";

export const Number = ({ label, required, helpText, ...props }) => {
    const { t } = useTranslation();
    const [field, meta] = useField(props);

    return (
        <div className={styles.numberInputContainer}>
            <div>
                {label &&
                    <label className={styles.numberInputLabel} htmlFor={props.id || props.name}>
                        {label}

                        {required && <span className={styles.required}>*</span>}
                    </label>
                }

                <input
                    {...field}
                    {...props}
                    id={props.id || props.name}
                    className={`${styles.numberInput} ${meta.error ? styles.errorInput : ''}`}
                    type="number"
                />
            </div>

            {(meta.touched && meta.error) &&
                <div className={styles.error}>{t('input_component.is_required')}</div>
            }

            {helpText &&
                <HelpText>{helpText}</HelpText>
            }
        </div>
    );
};
